import ENDPOINTS from '../../constants/apiEndPoints';
import {axiosInstance} from '../axiosInstance';

export const handleGetAllRoleTypesService = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_ROLE_TYPE);
  return response?.data;
};
